import { useEffect, useState } from 'react';

export const useOnInitialRender = (action: () => any): void => {
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    if (firstRender) {
      setFirstRender(false);
      action();
    }
  }, []);
};
